export const CONTAC_DASHBOARD_CONSULTOR = () => `/contac-dashboard-consultor`;
